import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { theme } from '@pinkyhead/dovekit';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { Routes } from './components/modules/Routes';
import { RootProvider } from './context/root';
import { AuthProvider } from './context/auth';
import { MapProvider } from './context/map';

const queryClient = new QueryClient()

const GlobalStyle = createGlobalStyle`
  * {
    font-family: Lato;
    box-sizing: border-box;
  }
  body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  button {
    cursor: pointer;
    outline: none;
  }
  .leaflet-container {
    font: unset;
  }
`;

function App() {
  return (
    <>
      <GlobalStyle />
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <MapProvider>
              <AuthProvider>
                <RootProvider>
                  <Routes />
                </RootProvider>
              </AuthProvider>
              {/* <ReactQueryDevtools /> */}
            </MapProvider>
          </QueryClientProvider>
        </BrowserRouter>
      </ThemeProvider>
    </>
  );
}

export default App;
